import { General } from "@/services/General";
import axios from "axios";

export class MainVar{
    dropDownListLastUpdate: Date;
    translationsLastUpdate: Date;
    lastEndpointCheck: number;
    net20PotentialVolumeLimitsLastUpdate: Date;
    net20SupplierRequestExclusionsLastUpdate: Date;
    net20ExcludedContractStepsUpdate: Date;
    net20FieldConfigurationsUpdate: Date;
    net20PlannedSignInstallationDefaultsUpdate: Date;
    net20ContractConfigurationsUpdate: Date;

    constructor() {
        this.dropDownListLastUpdate = null;
        this.translationsLastUpdate = null;
        this.lastEndpointCheck = null;
        this.net20PotentialVolumeLimitsLastUpdate = null;
        this.net20SupplierRequestExclusionsLastUpdate = null;
        this.net20ExcludedContractStepsUpdate = null;
        this.net20FieldConfigurationsUpdate = null;
        this.net20PlannedSignInstallationDefaultsUpdate = null;
        this.net20ContractConfigurationsUpdate = null;
    }

    public async GetAsync() {
        let timeSpan = Date.now() - this.lastEndpointCheck;
        if(this.lastEndpointCheck === undefined || timeSpan >= 60000) {
            let response = await axios.get<MainVar>(
                General.GetApiUrl('/api/utils/GetMainDbVar'),{
                responseType: "json",
                withCredentials: true
            });
            if(response.data) {
                this.dropDownListLastUpdate = response.data.dropDownListLastUpdate;
                this.translationsLastUpdate = response.data.translationsLastUpdate;
                this.net20PotentialVolumeLimitsLastUpdate = response.data.net20PotentialVolumeLimitsLastUpdate;
                this.net20SupplierRequestExclusionsLastUpdate = response.data.net20SupplierRequestExclusionsLastUpdate;
                this.net20ExcludedContractStepsUpdate = response.data.net20ExcludedContractStepsUpdate;
                this.net20FieldConfigurationsUpdate = response.data.net20FieldConfigurationsUpdate;
                this.net20PlannedSignInstallationDefaultsUpdate = response.data.net20PlannedSignInstallationDefaultsUpdate;
                this.net20ContractConfigurationsUpdate = response.data.net20ContractConfigurationsUpdate;
                this.lastEndpointCheck = Date.now();
            }
        }
    }

    public IsRecent(previousMainVar: MainVar) {
        if(this == null
            || (!this.dropDownListLastUpdate || this.dropDownListLastUpdate > previousMainVar.dropDownListLastUpdate)
            || (!this.translationsLastUpdate || this.translationsLastUpdate > previousMainVar.translationsLastUpdate)
            || (!this.net20PotentialVolumeLimitsLastUpdate || this.net20PotentialVolumeLimitsLastUpdate > previousMainVar.net20PotentialVolumeLimitsLastUpdate)
            || (!this.net20SupplierRequestExclusionsLastUpdate || this.net20SupplierRequestExclusionsLastUpdate > previousMainVar.net20SupplierRequestExclusionsLastUpdate)
            || (!this.net20ExcludedContractStepsUpdate || this.net20ExcludedContractStepsUpdate > previousMainVar.net20ExcludedContractStepsUpdate)
            || (!this.net20FieldConfigurationsUpdate || this.net20FieldConfigurationsUpdate > previousMainVar.net20FieldConfigurationsUpdate)
            || (!this.net20PlannedSignInstallationDefaultsUpdate || this.net20PlannedSignInstallationDefaultsUpdate > previousMainVar.net20PlannedSignInstallationDefaultsUpdate)
            || (!this.net20ContractConfigurationsUpdate || this.net20ContractConfigurationsUpdate > previousMainVar.net20ContractConfigurationsUpdate))
            return true;
        else
            return false;
    }
}